import { Controller } from "@hotwired/stimulus";

// Client-side text search for any list of items.
// Matches the query against each item's data-search-names attribute (lowercase).
// Toggles "hidden-by-search" CSS class on non-matching items.
//
// Plays nicely with other filter controllers that follow the same convention
// of toggling "hidden-by-*" classes — an item is visible only when it has
// no hidden-by-* class.
//
// Usage:
//   <div data-controller="list-search">
//     <input data-list-search-target="input" data-action="input->list-search#filter">
//     <div data-list-search-target="group">
//       <h3>A</h3>
//       <ul>
//         <li data-list-search-target="item" data-search-names="apple">Apple</li>
//       </ul>
//     </div>
//   </div>
export default class extends Controller {
  static targets = ["input", "item", "group", "counter"];

  connect() {
    this.totalCount = this.itemTargets.length;
  }

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase();

    this.itemTargets.forEach((el) => {
      const names = el.dataset.searchNames || "";
      el.classList.toggle(
        "hidden-by-search",
        query.length > 0 && !names.includes(query),
      );
    });

    this.updateLayout();
  }

  clear() {
    this.inputTarget.value = "";
    this.filter();
  }

  // --- private ---

  isHidden(el) {
    return Array.from(el.classList).some((c) => c.startsWith("hidden-by-"));
  }

  updateLayout() {
    let visibleCount = 0;
    this.itemTargets.forEach((el) => {
      if (!this.isHidden(el)) visibleCount++;
    });

    this.groupTargets.forEach((group) => {
      const items = group.querySelectorAll('[data-list-search-target="item"]');
      const anyVisible = Array.from(items).some((el) => !this.isHidden(el));
      group.style.display = anyVisible ? "" : "none";
    });

    if (this.hasCounterTarget) {
      if (visibleCount < this.totalCount) {
        this.counterTarget.textContent = `Showing ${visibleCount} of ${this.totalCount} denominations`;
        this.counterTarget.style.display = "";
      } else {
        this.counterTarget.style.display = "none";
      }
    }
  }
}
